export const actionStrings = {
  authLogin: "AUTH_LOGIN",
  authLogout: "AUTH_LOGOUT",
  register: "REGISTER",
  authReset: "AUTH_RESET",
  pending: "_PENDING",
  fulfilled: "_FULFILLED",
  rejected: "_REJECTED",
  getProducts: "_GET_PRODUCTS",
  createProduct: "_CREATE_PRODUCT",
  updateProducts: "_UPDATE_PRODUCT",
  getDetailProduct: "_GET_PRODUCT_DETAIL",
  getProfile: "_GET_PROFILE",
  editProfile: "_UPDATE_PROFILE",
  getPromos: "_GET_PROMOS",
  counterUp: "COUNTER_UP",
  counterDown: "COUNTER_DOWN",
  counterReset: "COUNTER_RESET",
  addCart: "ADD_CART",
  dataCheckout: "DATA_CHECKOUT",
  getCategories: "GET_CATEGORIES",
  getRelatedProduct: "GET_RELATED_PRODUCT",
  getSellerProduct: "GET_SELLER_PRODUCT",
  getOrderSeller: "GET_ORDER_SELLER",
  getOrderCustomer: "GET_ORDER_CUSTOMER",
};
